import { render, staticRenderFns } from "./DocAdView.vue?vue&type=template&id=936f6eb0&scoped=true&"
import script from "./DocAdView.vue?vue&type=script&lang=js&"
export * from "./DocAdView.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/all.css?vue&type=style&index=0&id=936f6eb0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "936f6eb0",
  null
  
)

export default component.exports